export const selectAuthUser = (state) => state.auth.user;
export const selectAuthLoading = (state) => state.auth.isLoading;
export const selectAuthError = (state) => state.auth.error;

export const resetLoading = (state) => state.auth.resetLoading;
export const resetError = (state) => state.auth.resetError;

export const changeLoading = (state) => state.auth.changeLoading;
export const changeError = (state) => state.auth.changeError;

export const forgotLoading = (state) => state.auth.forgotLoading;
export const forgotError = (state) => state.auth.forgotError;
